<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">
            <div class="row align-items-center text-start">
                <div class="col-7 col-12-narrower">
                    <div class="eyebrow" i18n>Künstliche Intelligenz für Unternehmen</div>
                    <header>
                        <h2 i18n>KI-Agenten, die Ihre Mitarbeiter sinnvoll unterstützen</h2>
                    </header>
                    <p class="lead" i18n>Wir beraten Unternehmen bei der Einführung künstlicher Intelligenz und entwickeln <strong>individuelle KI-Assistenten und KI-Agenten</strong> für konkrete Arbeitsabläufe.</p>
                    <p i18n>Statt einer isolierten Chat-Lösung verbinden wir KI bei Bedarf mit Ihren Dokumenten, Portalen, Datenbanken und Schnittstellen. So entstehen nachvollziehbare Werkzeuge, die Wissen schneller zugänglich machen und wiederkehrende Aufgaben gezielt unterstützen.</p>
                </div>
                <div class="col-5 col-12-narrower">
                    <div class="visual-frame hero-preview">
                        <img src="/freepics/network.jpg" width="772" height="378" fetchpriority="high" alt="Vernetzte Systeme als Grundlage individueller KI-Agenten" i18n-alt />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container">
        <header class="major text-center">
            <h2 i18n>Von der KI-Idee bis zur integrierten Lösung</h2>
            <p i18n>Wir starten beim tatsächlichen Bedarf und wählen Technik und Automatisierungsgrad passend dazu aus.</p>
        </header>
        <div class="row features g-4">
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-lightbulb"></span>
                    <h3 i18n>KI-Beratung</h3>
                    <p i18n>Wir identifizieren sinnvolle Anwendungsfälle, bewerten Nutzen, Datenlage und Risiken und erstellen einen realistischen Weg vom ersten Test bis zum produktiven Einsatz.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-robot"></span>
                    <h3 i18n>KI-Assistenten und Agenten</h3>
                    <p i18n>Individuelle Lösungen für Recherche, Wissenszugriff, Dokumentenverarbeitung und die Vorbereitung oder Ausführung klar definierter Aufgaben.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon featured fa-solid fa-plug-circle-bolt"></span>
                    <h3 i18n>Integration und Automatisierung</h3>
                    <p i18n>Anbindung an bestehende Software, APIs, Datenbanken, CRM-Systeme oder Webportale, damit KI dort unterstützt, wo Ihre Arbeit bereits stattfindet.</p>
                </div>
            </section>
        </div>
    </section>
</div>

<div class="wrapper use-case-wrapper">
    <section class="container text-start">
        <div class="row align-items-center g-5">
            <div class="col-5 col-12-narrower">
                <div class="visual-frame use-case-image">
                    <img src="/freepics/development.jpg" width="772" height="378" loading="lazy" alt="Planung und Entwicklung eines individuellen KI-Agenten" i18n-alt />
                </div>
            </div>
            <div class="col-7 col-12-narrower content-copy">
                <header class="major">
                    <h2 i18n>Konkrete Einsatzmöglichkeiten</h2>
                </header>
                <div class="use-case-grid">
                    <article>
                        <h3 i18n><span class="fa-solid fa-book-open"></span> Unternehmenswissen</h3>
                        <p i18n>Freigegebene Dokumente und Informationen schneller durchsuchen, zusammenfassen und mit nachvollziehbaren Quellen bereitstellen.</p>
                    </article>
                    <article>
                        <h3 i18n><span class="fa-solid fa-file-lines"></span> Dokumente</h3>
                        <p i18n>Inhalte erfassen, klassifizieren, vergleichen und für weitere Arbeitsschritte strukturiert vorbereiten.</p>
                    </article>
                    <article>
                        <h3 i18n><span class="fa-solid fa-headset"></span> Service und Tickets</h3>
                        <p i18n>Anfragen vorsortieren, Antwortentwürfe erstellen und zuständige Mitarbeiter mit relevanten Informationen unterstützen.</p>
                    </article>
                    <article>
                        <h3 i18n><span class="fa-solid fa-gears"></span> Abläufe</h3>
                        <p i18n>Definierte Schritte systemübergreifend vorbereiten oder ausführen – bei Bedarf mit verpflichtender menschlicher Freigabe.</p>
                    </article>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container text-start">
        <div class="row align-items-stretch g-5">
            <div class="col-7 col-12-narrower content-copy">
                <header class="major">
                    <h2 i18n>Kontrollierbar statt unübersichtlich</h2>
                </header>
                <p i18n>Ein guter KI-Agent bekommt nicht einfach Zugriff auf alles. Wir definieren gemeinsam, welches Wissen genutzt werden darf, welche Aktionen möglich sind und wann ein Mensch entscheiden muss.</p>
                <ul class="service-list">
                    <li i18n>Passende Auswahl von Modell, Betriebsform und Datenquellen</li>
                    <li i18n>Rollen, Berechtigungen und klar begrenzte Werkzeuge</li>
                    <li i18n>Nachvollziehbare Ergebnisse und Protokollierung wichtiger Abläufe</li>
                    <li i18n>Menschliche Freigaben für sensible oder geschäftskritische Aktionen</li>
                    <li i18n>Schrittweiser Einstieg über einen überschaubaren Prototyp</li>
                    <li i18n>Weiterentwicklung anhand echter Nutzung und Rückmeldungen</li>
                </ul>
            </div>
            <div class="col-5 col-12-narrower">
                <div class="agent-flow mb-4" aria-label="Ablauf eines KI-Agenten vom Auftrag über Wissen und Werkzeuge bis zur Freigabe" i18n-aria-label>
                    <div class="flow-step"><span class="fa-solid fa-user"></span><strong i18n>Auftrag</strong></div>
                    <span class="flow-arrow fa-solid fa-arrow-down"></span>
                    <div class="flow-step"><span class="fa-solid fa-brain"></span><strong i18n>KI-Agent</strong></div>
                    <div class="flow-tools">
                        <span i18n><i class="fa-solid fa-database"></i>Daten</span>
                        <span i18n><i class="fa-solid fa-file-shield"></i>Wissen</span>
                        <span i18n><i class="fa-solid fa-plug"></i>Systeme</span>
                    </div>
                    <span class="flow-arrow fa-solid fa-arrow-down"></span>
                    <div class="flow-step"><span class="fa-solid fa-user-check"></span><strong i18n>Ergebnis oder Freigabe</strong></div>
                </div>
                <div class="callout">
                    <h3 i18n>Sie haben eine KI-Idee?</h3>
                    <p i18n>Wir prüfen gemeinsam, ob der Anwendungsfall sinnvoll, technisch machbar und wirtschaftlich tragfähig ist.</p>
                    <div class="cta-actions">
                        <a routerLink="/contact" class="glow-on-hover p-3" i18n>KI-Anwendungsfall besprechen</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper faq-wrapper">
    <section class="container text-start">
        <header class="major text-center">
            <h2 i18n>Häufige Fragen zu KI-Agenten</h2>
        </header>
        <div class="faq-grid">
            <article class="faq-item">
                <h3 i18n>Was ist ein KI-Agent?</h3>
                <p i18n>Ein KI-Agent kombiniert ein Sprachmodell mit Unternehmenswissen, Regeln und angebundenen Werkzeugen. Dadurch kann er Informationen verarbeiten und definierte Arbeitsschritte unterstützen.</p>
            </article>
            <article class="faq-item">
                <h3 i18n>Muss ein KI-Agent autonom arbeiten?</h3>
                <p i18n>Nein. Berechtigungen, Grenzen und Freigabeschritte werden passend zum Prozess festgelegt. Kritische Aktionen können immer eine menschliche Bestätigung erfordern.</p>
            </article>
            <article class="faq-item">
                <h3 i18n>Kann vorhandenes Wissen genutzt werden?</h3>
                <p i18n>Ja. Je nach Anwendungsfall können freigegebene Dokumente, Datenbanken, Portale oder Schnittstellen unter Berücksichtigung der Zugriffsrechte angebunden werden.</p>
            </article>
        </div>
    </section>
</div>
